// import Navbar from "../../components/navbar/Navbar";
// import OutstandingCourses from "../../components/cephas-kids/OutstandingCourses";
// import { coursesData } from "../../components/cephas-kids/CourseData";
import allcourseimg from "../../assets/img/allcourseimg.png";
import OutstandingCourses from "../../components/cephas-kids/OutstandingCourses";
import { coursesData } from "../../components/cephas-kids/CourseData";
import Nav from "../../components/nav/nav.component";
import NewsletterSubscription from "../../components/cephas-kids/NewsletterSubscription";
import Footer from "../../components/footer/footer.component";
import Shake from "react-reveal/Shake";
import Jump from "react-reveal/Jump";

const AllCourses = () => {
  return (
    <div className="min-h-screen">
      <Nav />

      {/* Hero Section */}
      <div
        className="relative pt-32 min-h-screen flex items-center"
        style={{
          background: `linear-gradient(to right, rgba(255, 75, 1, 0.8), rgba(17, 50, 150, 0.78))`,
        }}
      >
        <div className="container mx-auto px-4 md:px-6 lg:px-28 lg:block md:hidden hidden ">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-24 items-center">
            <Jump>
              <div className="flex justify-center lg:justify-start">
                <img
                  src={allcourseimg || "/placeholder.svg"}
                  alt="Kids learning tech"
                  className="max-w-full h-auto rounded-lg"
                />
              </div>
            </Jump>

            <Shake>
              <div className="text-white text-center lg:w-[524px] lg:text-left  lg:mb-20 ">
                <h1 className="text-6xl md:text-6xl lg:text-[70px] tracking-wider font-DM_SANS font-black mb-6 lg:leading-tight">
                  Check out Our Tech courses
                </h1>
                <p className="text-xl md:text-2xl lg:text-3xl font-DM_SANS font-medium lg:w-96 opacity-90">
                  Let your kids learn to create, code, and think creatively
                </p>
              </div>
            </Shake>
          </div>
        </div>

        {/* Mobile hero */}
        <div className="container mx-auto px-4 md:px-6 lg:px-28 lg:hidden md:block block ">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-24 items-center">
            <Shake>
              <div className="text-white text-center lg:w-[524px] lg:text-left  lg:mb-20 ">
                <h1 className="text-5xl  tracking-wider font-DM_SANS font-black mb-6 lg:leading-tight">
                  Check out Our Tech courses
                </h1>
                <p className="text-lg font-DM_SANS font-medium lg:w-96 opacity-90">
                  Let your kids learn to create, code, and think creatively
                </p>
              </div>
            </Shake>

            <Jump>
              <div className="flex justify-center lg:justify-start">
                <img
                  src={allcourseimg}
                  alt="Kids learning tech"
                  className="max-w-full h-auto rounded-lg"
                />
              </div>
            </Jump>
          </div>
        </div>
      </div>

      {/* All Courses Section */}
      <div>
        <OutstandingCourses courses={coursesData} />
      </div>
      {/* Subscribing */}
      <div>
        <NewsletterSubscription />
      </div>
      {/* Footer */}
      <div>
        <Footer />
      </div>
    </div>
  );
};

export default AllCourses;
